'use client'
import React from 'react'
import LobyProfileCard from '../public-profile-card/lobyProfileCard'
import { TypesenseObj } from '@/lib/typesenseFunction'

const AdvancedSearch = ({ hit }: TypesenseObj) => {
  return (
    <LobyProfileCard profileData={hit} />
  )
}
export default AdvancedSearch
